export default __webpack_public_path__ + "static/media/ei-picture.e8e541e0.svg";